const tools = [
  {
    icon: 'ri-graduation-cap-line',
    title: 'Обучение',
    desc: 'Получение необходимых знаний и инструментов.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Практика',
    desc: 'Применение новых навыков в реальных рабочих ситуациях.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Наставничество',
    desc: 'Работа с более опытным сотрудником или руководителем.',
  },
  {
    icon: 'ri-task-line',
    title: 'Развивающие задачи',
    desc: 'Задачи, которые немного выходят за привычную зону ответственности.',
  },
  {
    icon: 'ri-git-branch-line',
    title: 'Проектная работа',
    desc: 'Участие в проектах, где сотруднику необходимо проявить новые компетенции.',
  },
  {
    icon: 'ri-exchange-line',
    title: 'Временная замена руководителя',
    desc: 'При наличии соответствующих условий — временное выполнение части функций будущей роли.',
  },
  {
    icon: 'ri-chat-3-line',
    title: 'Обратная связь',
    desc: 'Регулярный разбор поведения и результатов.',
  },
  {
    icon: 'ri-mic-line',
    title: 'Коучинг',
    desc: 'Индивидуальная работа над конкретными зонами развития.',
  },
];

export default function HowDevelopReservist() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как развивать резервиста
        </h2>
        <p className="text-teal-700 font-semibold text-center text-base md:text-lg mb-12">
          Развитие не должно ограничиваться обучением
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {tools.map((t, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${t.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{t.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}